<template>
  <div class="s-canvas">
    <img :src="url" @click="getCode">
  </div>
</template>
<script>


import {Toast} from "vant";

export default {
  name: 'SIdentify',
  data() {
    return {
      url: "",
      uuid:''
    }
  },

  methods: {
    getCode() {
      this.$ajax.post("/etv/getCaptchaCode.json").then(res => {
        let data = res.data.data
        if(res.data.code===0){
          // 检查data.imgVal是否存在并且是字符串
          if (data.imgVal && typeof data.imgVal === 'string') {
            // 添加前缀"data:image/jpeg;base64,"以便浏览器能够识别Base64编码的图像数据
            this.url = 'data:image/jpeg;base64,' + data.imgVal;
          }
          this.uuid = data.uuid;
          // 现在，您需要在父组件中设置这个 uuid
          this.$emit('update:uuid', this.uuid);
        }else {
          //this.$elementMessage(res.data.msg, 'error')
          Toast(res.data.msg,'fail')
        }

      })
    }
  },
  mounted() {
    this.getCode()
  }
}
</script>
<style lang="scss">
.s-canvas {
  width: 60%;
  height: 48px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>

